import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsImagePageNavView from "scripts/views/contentDetailsImagePageNavView";

import templateContentDetailsImagePage from "templates/contentDetailsImagePage.hbs";

class ContentDetailsImagePageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );

    this.initializeBookshelfDeps();
  }

  get template() {
    return templateContentDetailsImagePage;
  }

  render() {
    super.render();
    super.renderBookshelfElements();

    return this;
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsImagePageNavView({
      model: this.model,
      organizationProperties,
    });
  }
}

export default ContentDetailsImagePageView;
